import { getService } from "src/helpers/isPes";
import { isLek as isLekBrand } from "src/helpers/services";
import { getUserInfo } from "src/hooks/useUser";

/**
 * Zwraca serwis, do ktorego user powinien sie przelaczyc, gdy zalogowal sie
 * do egzaminu bez dostepu, a ma dostep do drugiego (LEK <-> PES).
 * Tylko brand egzaminlek — na ldek/lekexam nie ma PES.
 */
function getWrongServiceTarget() {
	if (!isLekBrand()) {
		return null;
	}

	const services = getUserInfo().availableServices || [];
	const hasBasic = services.includes("BASIC");
	const hasPes = services.includes("PES");

	if (getService() === "LEK" && !hasBasic && hasPes) {
		return "PES";
	}

	if (getService() === "PES" && !hasPes && hasBasic) {
		return "LEK";
	}

	return null;
}

function hasAccessToPesExams() {
	const user = getUserInfo();

	return user.hasAccess;
}

function hasAccessToLekExams() {
	const user = getUserInfo();

	return user.hasAccess;
}

function hasLimitedAccess() {
	const user = getUserInfo();

	return user.hasLimitedAccess;
}

function hasAnyAccess() {
	return hasAccessToPesExams() || hasAccessToLekExams();
}

export {
	getWrongServiceTarget,
	hasAccessToLekExams,
	hasAccessToPesExams,
	hasAnyAccess,
	hasLimitedAccess,
};
